import React from 'react'
import { useTranslation } from 'react-i18next'
import { MegaTagTitle } from '@/components/Elements'
import { GeneralInvoicesContainer } from '@/features/billing/components/Invoice/Invoices'

export const Invoices = () => {
  const { t } = useTranslation()

  return (
    <>
      <MegaTagTitle title={'invoices'} />

      <GeneralInvoicesContainer />
    </>
  )
}
